exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[class*=\"icheck-\"] > label[data-v-7a8cec50] {\n  color: black;\n}\n.d-i-b[data-v-7a8cec50] {\n  display: inline-block;\n}\n", ""]);

// exports
